var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sd-input"},[(!_vm.area)?_c('input',{attrs:{"type":_vm.type,"placeholder":_vm.localPlaceholder},domProps:{"value":_vm.value},on:{"input":_vm.handleInput}}):_c('textarea',{attrs:{"rows":"5","placeholder":_vm.localPlaceholder},on:{"input":_vm.handleInput}})])
}
var staticRenderFns = []

export { render, staticRenderFns }